import styled from 'styled-components';
import { Box } from '@rsos/base-components';

export const ShareLinkContainer = styled(Box).attrs({
  border: '1px solid',
  borderColor: 'lightLineDivider',
  borderRadius: '4px',
  p: '16px',
  mb: '8px',
})`
  word-break: break-all;
`;

export const LimitReachedWrapper = styled(Box).attrs({
  mb: 16,
  padding: '12px 20px',
  bg: 'lightDanger',
  borderRadius: '4px',
  horizontal: true,
  align: 'center',
  flow: 12,
  color: 'background',
})``;
